import { FC } from "react";
import SmartSearchAndActionsLayout from "../../../components/Layouts/smart-search-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetBingoActiveSitesParams,
  getBingoActiveSites,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const BingoActiveSites: FC = () => {
  return (
    <SmartSearchAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      labels={["active"]}
      onRefresh={(output, params) => {
        const getBingoActiveSitesParams: GetBingoActiveSitesParams = {
          output: output,
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getBingoActiveSitesParams[id] = params.id;
        }

        return getBingoActiveSites(getBingoActiveSitesParams);
      }}
    />
  );
};

export default BingoActiveSites;
